export const BUSINESS_PARTNER_GET_LIST = "/businessPartner";
export const CHECK_BUSINESS_PARTNER = "/businessPartner/check";